import { envConfig } from './EnvConfig';

export const AppConfig = {
    consumerId: 'e-store-eu',
    versionId: envConfig.headlessVersion,
    userAgent: 'e-store-eu headless',
};
